if (!customElements.get('sticky-atc')) {
  customElements.define(
    'sticky-atc',
    class StickyAtc extends HTMLElement {
      connectedCallback() {
        this.sectionId = this.dataset.section;
        this.button = this.querySelector('.sticky-atc__submit');
        this.buttonText = this.button ? this.button.querySelector('span') : null;
        this.priceElement = this.querySelector('.sticky-atc__price');
        this.mainForm = this.button ? document.getElementById(this.button.getAttribute('form')) : null;
        this.mainButton = this.mainForm ? this.mainForm.querySelector('[name="add"]') : null;
        if (!this.button || !this.mainForm || !this.mainButton) return;

        // Optional secondary action (product.offers only): forwards to the Magical
        // Make an Offer block button. Stays hidden unless that button exists.
        this.offerButton = this.querySelector('[data-sticky-offer]');
        if (this.offerButton) this.initOfferButton();

        // Show the bar only once the main buy-buttons block has scrolled up out of view.
        this.intersectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
            this.classList.toggle('sticky-atc--visible', scrolledPast);
          });
        });
        this.intersectionObserver.observe(this.mainForm);

        // Mirror the main button's disabled state and label ("Add to cart" / "Sold out" /
        // "Unavailable"), which Dawn's variant-selects/variant-radios keep up to date.
        this.mutationObserver = new MutationObserver(() => this.syncButton());
        this.mutationObserver.observe(this.mainButton, {
          attributes: true,
          attributeFilter: ['disabled'],
          childList: true,
          characterData: true,
          subtree: true,
        });

        // Update the price when the variant changes (published by variant-selects in global.js).
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (!event || !event.data || event.data.sectionId !== this.sectionId) return;
            this.syncPrice();
            this.syncButton();
          });
        }
      }

      initOfferButton() {
        const target = () => document.getElementById('ma-make-an-offer-open-button');
        const reveal = () => {
          this.offerButton.hidden = false;
          this.classList.add('sticky-atc--two-actions');
        };
        this.offerButton.addEventListener('click', () => {
          const button = target();
          if (button) button.click();
        });
        if (target()) {
          reveal();
          return;
        }
        // The app block can finish rendering after this element connects; watch
        // briefly and give up quietly if the app never renders its button.
        this.offerObserver = new MutationObserver(() => {
          if (!target()) return;
          reveal();
          this.offerObserver.disconnect();
        });
        this.offerObserver.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => this.offerObserver && this.offerObserver.disconnect(), 8000);
      }

      disconnectedCallback() {
        if (this.intersectionObserver) this.intersectionObserver.disconnect();
        if (this.offerObserver) this.offerObserver.disconnect();
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.variantChangeUnsubscriber) this.variantChangeUnsubscriber();
      }

      syncButton() {
        if (!this.mainButton) return;
        const mainText = this.mainButton.querySelector('span');
        if (mainText && this.buttonText) this.buttonText.textContent = mainText.textContent.trim();
        this.button.toggleAttribute('disabled', this.mainButton.hasAttribute('disabled'));
      }

      syncPrice() {
        if (!this.priceElement) return;
        const priceRoot = document.getElementById(`price-${this.sectionId}`);
        if (!priceRoot || priceRoot.classList.contains('visibility-hidden')) return;
        const price = priceRoot.querySelector('.price');
        if (!price) return;
        const selector = price.classList.contains('price--on-sale')
          ? '.price__sale .price-item--sale'
          : '.price__regular .price-item--regular';
        const priceItem = price.querySelector(selector);
        if (priceItem) this.priceElement.textContent = priceItem.textContent.trim();
      }
    }
  );
}
